import script from "./NoPost.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoPost.vue?vue&type=script&setup=true&lang=ts"

import "./NoPost.vue?vue&type=style&index=0&id=890b02c0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-890b02c0"]])

export default __exports__